<template>
  <v-dialog
    v-model="dialogDetail"
    persistent
    max-width="1200px"
    transition="dialog-transition"
    @keyup.esc="close"
  >
    <v-card flat class="no__radius no__padding-scroll table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1" v-if="!loading">
      <v-card-title>
        <h2>Detail spoření</h2>
      </v-card-title>
      <div class="gui-flex gui-flex-rows" v-if="!editMode">

        <v-dialog
          v-model="dialogZmenitCilovyProdukt"
          scrollable
          persistent
          max-width="600px"
          transition="dialog-transition"
          class="pa-0"
          v-if="dialogZmenitCilovyProdukt"
        >
          <v-card class="ma-0 pa-0">
            <v-card-title primary-title>
              <h3>Změna cílového produktu</h3>
            </v-card-title>
            <v-card-text class="pt-0">
              <productsearch loadOnMounted v-model="zmena_cilovy_produkt_id" :material="item.cilovy_produkt.material.id" sporici></productsearch>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-if="zmena_cilovy_produkt_id != null" depressed @click="zmenitCilovyProdukt" :loading="saving">Změnit cílový produkt</v-btn>
              <v-btn color="grey lighten-2" depressed @click="dialogZmenitCilovyProdukt=false" v-if="!saving">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogZmenitCilovyProduktSmazat"
          scrollable
          persistent
          max-width="600px"
          transition="dialog-transition"
          class="pa-0"
          v-if="dialogZmenitCilovyProduktSmazat"
        >
          <v-card class="ma-0 pa-0">
            <v-card-title primary-title>
              <h3>Smazání změny cílového produktu</h3>
            </v-card-title>
            <v-card-text class="pt-0">
              Opravu chete vymazat změnu na cílový produkt {{item.zmena_cilovy_produkt.nazev}}?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" dark depressed @click="zmenitCilovyProduktSmazat" :loading="saving">Smazat změnu cílového produktu</v-btn>
              <v-btn color="grey lighten-2" depressed @click="dialogZmenitCilovyProduktSmazat=false" v-if="!saving">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogRemove"
          max-width="400px"
        >
          <v-card>
            <v-card-title primary-title>
              <h3 class="text-xs-center">Opravdu chcete smazat toto spoření?</h3>
            </v-card-title>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn color="red" class="white--text" depressed @click="remove" :loading="removing">Ano, smazat</v-btn>
              <v-btn color="grey lighten-3" @click="dialogRemove=false" depressed>Zrušit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card color="grey lighten-4" class="pt-1 pl-3 pr-3 mt-4 pb-1 elevation-0">
          <v-card-text>
            <v-tabs v-model="activeTab" color="transparent" slot="extension" class="mlm10">
              <v-tab :key="1" ripple>
                Informace
              </v-tab>
              <v-tab :key="2" ripple>
                Platby (peněženka)
              </v-tab>
              <v-tab :key="3" ripple>
                Platby (na účet)
              </v-tab>
              <v-tab :key="4" ripple>
                Roční bonusy
              </v-tab>
              <v-tab :key="5" ripple>
                Graf spoření
              </v-tab>
              <v-tab :key="6" ripple>
                Předané produkty
              </v-tab>
              <v-tab :key="7" ripple>
                Ostatní
              </v-tab>
            </v-tabs>
            <div class="pl-2 pr-3">
              <v-card color="grey lighten-4" class="pa-1 mt-4 elevation-0">
                <v-card-text class="pa-0">
                  <v-tabs-items v-model="activeTab">
                    <v-tab-item :key="1">
                      <v-card color="grey lighten-4" class="pa-0 mt-3 elevation-0">
                        <v-card-text class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h3>Obecné informace</h3>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Název spoření:</p> <strong>{{item.nazev_sporeni}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Spořící program:</p> <strong><router-link target="_blank" :to="{ path: '/sporici-produkty/'+item.sporici_produkt.id }">{{item.sporici_produkt.sporici_program}}</router-link></strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Datum sjednání:</p> <strong>{{item.datum_sjednani | formatDate}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <v-card color="grey lighten-4" class="pa-0 mt-5 elevation-0">
                        <v-card-text class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h3>Aktuální stav</h3>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Zaplacen vstupní poplatek:</p> <strong><span v-if="item.zaplacen_vstupni_poplatek">Ano</span><span v-else>Ne</span></strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Zaplaceno celkem:</p> <strong>{{item.celkem_zaplaceno | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Naspořeno kusů (cílového produktu):</p> <strong>{{item.pocet_dosporenych_produktu}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Předáno kusů:</p> <strong>{{item.predane_produkty.length}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Cílový produkt:</p> <router-link :to="{ path: '/produkty/' + item.cilovy_produkt.id }" target="_blank"><strong>{{item.cilovy_produkt.nazev}}</strong></router-link><v-btn color="primary" outline small class="ma-0 ml-3" style="min-width: 0" @click="zmenitCilovyProduktClick"><v-icon small>edit</v-icon></v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md3 v-if="item.zmena_cilovy_produkt != null">
                              <p class="grey--text caption mb-1">Cílový produkt ke změně:</p> <router-link :to="{ path: '/produkty/' + item.zmena_cilovy_produkt.id }" target="_blank"><strong>{{item.zmena_cilovy_produkt.nazev}}</strong></router-link><v-btn color="red" outline small class="ma-0 ml-3" style="min-width: 0" @click="zmenitCilovyProduktSmazatClick"><v-icon small>delete</v-icon></v-btn>
                            </v-flex>
                          </v-layout>
                          <!--<v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Cílový produkt aktuální:</p> <strong>{{item.cilovy_produkt.nazev}}</strong>
                            </v-flex>
                          </v-layout>-->
                        </v-card-text>
                      </v-card>

                      <v-card color="grey lighten-4" class="pa-0 mt-5 mb-3 elevation-0">
                        <v-card-text class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h3>Nastavení spořícího programu</h3>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Cílová částka:</p> <strong>{{item.cilova_castka | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Způsob platby vstupního poplatku:</p> <strong>
                                <span v-if="item.typ_vstupni_poplatek=='zadny'">Žádný</span>
                                <span v-else-if="item.typ_vstupni_poplatek=='na_zacatku'">Na začátku</span>
                                <span v-else-if="item.typ_vstupni_poplatek=='ve_sporeni'">Během spoření</span>
                              </strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Měsíční platba:</p> <strong>{{item.mesicni_platba | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-5">
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">Vstupní poplatek:</p> <strong>{{item.vstupni_poplatek_celkem | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <p class="grey--text caption mb-1">První platba:</p> <strong>{{item.prvni_platba | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="2"><Platby :id="id" :program="item.id.toString()"></Platby></v-tab-item>
                    <v-tab-item :key="3"><PlatbyUcet :id="id" :program="item.id.toString()"></PlatbyUcet></v-tab-item>
                    <v-tab-item :key="4"><RocniBonusy :bonusy="item.bonusovy_kov" :mena="item.mena" :narok="item.bonusovy_kov_narok"></RocniBonusy></v-tab-item>
                    <v-tab-item :key="5"><GrafSporeni :pocet_rozesporenych_g="item.pocet_rozesporenych_g" :procento="item.nasporena_castka_procento >= 100 ? 100 : item.rozesporeno_procent" :obrazek="item.cilovy_produkt.obrazky.length > 0 ? ($imagesBaseUrl + item.cilovy_produkt.obrazky[0].s3_nazev) : null"></GrafSporeni></v-tab-item>
                    <v-tab-item :key="6"><PredaneProdukty :polozky="item.predane_produkty"></PredaneProdukty></v-tab-item>
                    <v-tab-item :key="7">
                      <v-btn color="red" depressed class="ma-0 white--text" v-if="item.povolit_smazani" @click="removeClick"><v-icon small class="mr-2">delete</v-icon>Smazat spoření</v-btn>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </v-card>

        <v-card-actions class="mt-4">
          <!--<v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>-->
          <a :href="api_url + 'osoby/' + $props.klient + '/sporici-programy/' + $props.id + '/pdf'" target="_blank"><v-btn color="primary" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn></a>
          <v-btn color="red" flat @click.stop="dialog = true" :disabled="sporeniUkonceno">Ukončit spoření</v-btn>
            <v-dialog v-model="dialog" max-width="400">
              <v-card>
                <v-card-title class="headline">Chcete ukončit spoření?</v-card-title>
                <v-card-text>U spoření bude změněn stav "PROBÍHÁ" na "DOKONČENO". Další případné platby nebudou připsány do spoření, ale do elektronické peněženky. Po ukončení budou smazány rozespořené a bonusové gramy. Tento krok je nevratný.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat="flat" @click="dialog = false">Ne</v-btn>
                  <v-btn color="red" dark @click="ukoncitSporiciProdukt" :loading="loader" >Ano, ukončit</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-3 elevation-0" @click="() => { this.$emit('close') }" v-if="!updating">Zavřít</v-btn>
        </v-card-actions>
      </div>

      <div class="gui-flex gui-flex-rows" v-else>
        <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <p class="body-3 mb-0 bold">Obecné informace</p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md3>
                <v-text-field label="Název spoření" v-model="updateItem.nazev_sporeni" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <sporiciproduktsearch label="Spořící program" v-model="updateItem.sporici_produkt" @changed="newItemSporiciProduktChanged" class="mx-2"></sporiciproduktsearch>
                <!--<v-text-field label="Spořící program" v-model="updateItem.sporici_produkt" class="mx-2"></v-text-field>-->
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Datum sjednání" v-model="updateItem.datum_sjednani" class="mx-2"></v-text-field>
                <!--<datetimepicker v-model="updateItem.datum_sjednani" class="mx-2"></datetimepicker>-->
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Jméno klienta" class="mx-2"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md3>
                <v-text-field label="Telefon" v-model="updateItem.telefon" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Email" v-model="updateItem.email" class="mx-2"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <p class="body-3 mb-0 bold">Aktuální stav</p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md3>
                <v-text-field label="Zaplaceno celkem" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Naspořeno kusů (cílového produktu)" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Předáno kusů" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <!--<v-text-field label="Cílový produkt" class="mx-2"></v-text-field>-->
                <sporiciproduktsearch label="Cílový produkt" v-model="updateItem.cilovy_produkt" @changed="newItemSporiciProduktChanged" class="mx-2"></sporiciproduktsearch>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md3>
                <!--<v-text-field label="Cílový produkt aktuální" class="mx-2"></v-text-field>-->
                <sporiciproduktsearch label="Cílový produkt aktuální" v-model="updateItem.cilovy_produkt" @changed="newItemSporiciProduktChanged" class="mx-2"></sporiciproduktsearch>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Cílová částka" v-model="updateItem.cilova_castka" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Vstupní poplatek" v-model="updateItem.vstupni_poplatek" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Způsob platby vstupního poplatku" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Měsíční platba" v-model="updateItem.mesicni_platba" class="mx-2"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 md12>
                <v-text-field label="Variabilní symbol (tel. + pořadí spořícího programu, např. 7241357351)" v-model="updateItem.variabilni_symbol" class="mx-2"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card-actions class="mt-4">
          <v-btn color="primary" class="elevation-0" @click="edit" :loading="updating"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
        </v-card-actions>
      </div>
    </v-card>
    <v-card v-else>
      <v-card-text class="pa-5">
        <Loader skin="light"></Loader>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import GrafSporeni from '@/pages/Klienti/GrafSporeni'
import Platby from '@/pages/Klienti/Platby'
import PlatbyUcet from '@/pages/Klienti/PlatbyUcet'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'
export default {
  extends: Base,
  data () {
    return {
      dialogDetail: true,
      loading: true,
      editMode: false,
      activeTab: 0,
      tabs: [ 'informace', 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      newItem: {},
      updating: false,
      dialogRemove: false,
      removing: false,
      dialogZmenitCilovyProdukt: false,
      zmena_cilovy_produkt_id: null,
      saving: false,
      dialogZmenitCilovyProduktSmazat: false,
      dialog: false,
      loader: false
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    },
    sporeniUkonceno() {
      return this.item.stav_sporeni === 'dokonceno' || this.item.stav_sporeni === 'zruseno'
    }
  },
  props: {
    klient: [ String, Number ],
    id: [ String, Number ]
  },
  mounted: function() {
    this.load();
  },
  methods: {
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.editMode = true;
    },
    edit () {
      this.updating = true;
      window.api.put("osoby/" + this.$props.id + "/sporici-programy/" + this.$props.id, this.updateItem).then((_body) => {
        if (_body.updated) {
          this.item = window.th.copy(this.updateItem);
          this.editMode = false;
        }
        this.updating = false;
      }).catch((err) => {
        console.log(err);
        this.updating = false;
      });
    },
    load (fn) {
      window.api.get("osoby/" + this.$props.klient + "/sporici-programy/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
        if (typeof fn == "function")
          fn();
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    newItemSporiciProduktChanged () {

    },
    newItemSporiciProduktChanged (v) {

      this.newItem.sporici_produkt = v;

      if (this.newItem.nazev_sporeni === null || this.newItem.nazev_sporeni.length === 0)
        this.newItem.nazev_sporeni = v.sporici_program;

      if (this.newItem.cilova_castka === null || this.newItem.cilova_castka < v.min_cilova_castka)
        this.newItem.cilova_castka = v.min_cilova_castka;

      if (this.newItem.mesicni_platba === null || this.newItem.mesicni_platba < v.min_mesicni_splatka)
        this.newItem.mesicni_platba = v.min_mesicni_splatka;

      if (this.newItem.prvni_platba === null || this.newItem.prvni_platba < v.min_cilova_castka * parseFloat(v.poplatek_kredity) / 100)
        this.newItem.prvni_platba = v.min_cilova_castka * parseFloat(v.poplatek_kredity) / 100;

    },
    save () {

    },
    close () {
      this.$emit("close");
    },
    removeClick () {
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("osoby/" + this.$props.id + "/sporici-programy/" + this.$props.id).then((_body) => {
        if (_body.removed) {
          this.$emit("changed");
          this.close();
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    zmenitCilovyProduktClick() {
      this.dialogZmenitCilovyProdukt = true;
      this.zmena_cilovy_produkt_id = null;
    },
    zmenitCilovyProdukt () {
      this.saving = true;
      window.api.put("osoby/" + this.$props.id + "/sporici-programy/" + this.$props.id + "/cilovy-produkt", {
        cilovy_produkt_id: this.zmena_cilovy_produkt_id
      }).then((_body) => {
        if (_body.updated) {
          this.load(() => {
            this.saving = false;
            this.dialogZmenitCilovyProdukt = false;
          })
        }
        else {
          this.saving = false;
        }
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    zmenitCilovyProduktSmazatClick () {
      this.dialogZmenitCilovyProduktSmazat = true;
    },
    zmenitCilovyProduktSmazat () {
      this.saving = true;
      window.api.delete("osoby/" + this.$props.id + "/sporici-programy/" + this.$props.id + "/cilovy-produkt/zmena").then((_body) => {
        if (_body.updated) {
          this.dialogZmenitCilovyProduktSmazat = false;
          this.loading = true;
          this.load();
        }
        else {
          this.saving = false;
        }
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    ukoncitSporiciProdukt() {
      this.loader = true;
      const url = 'osoby/' + this.$props.klient + '/sporici-programy/' + this.$props.id + '/ukoncit-sporeni'
      window.api.put(url)
      .then(body => {
        if(body.status === 200) {
            this.loader = false;
            this.dialog = false;
            this.$router.push({name: 'KlientDetailTab4', params: { id: this.$props.klient }})
        }
      })
      },
    },
  components: {
    RocniBonusy, Platby, PlatbyUcet, PredaneProdukty, GrafSporeni
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/SporiciProgramDialog.vue